import { useStaticQuery, graphql } from 'gatsby';

type TLocationName =
  | 'Brisbane'
  | 'Logan'
  | 'Gold Coast'
  | 'Noosa'
  | 'Maroochydore';

type TLocation = {
  name: TLocationName;
  address: string;
  googleMapsEmbedUri: string;
};

type TLocationsQuery = {
  allVariablesYaml: {
    nodes: Array<{
      locations: TLocation[];
    }>;
  };
};

const useLocations = () => {
  const { allVariablesYaml } = useStaticQuery<TLocationsQuery>(
    graphql`
      query Locations {
        allVariablesYaml(filter: { type: { eq: "Locations" } }) {
          nodes {
            locations {
              name
              address
              googleMapsEmbedUri
            }
          }
        }
      }
    `,
  );

  const [nodes] = allVariablesYaml.nodes;

  return nodes.locations;
};

export { useLocations };
export type { TLocationName };
